import React from 'react';
import MainReaderTableApp from "../Functionality/MainReaderTableApp";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import DeleteModal from "../../../../Modals/DeleteModal";
import CreateReaderModal from "../Modal/CreateReaderModal";
import CustomTable from "../../../../../components/table/CustomTable";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MainReaderTable = (props) => {

    const { deleteReaderShow,
        setDeleteReaderShow,
        readerModalShow,
        setReaderModalShow,
        selectedList,
        setSelectedList
    } = props;

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        rowsPerPage,
        setResults,
        option,
        searchElement,
        setSearchElement,
        setSearch,
        setBodyForExport,
        setSimpleSearch,
        deletePermission,
        isAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedReader
    } = MainReaderTableApp({
        selectedList,
        setSelectedList
    });

    return (
        <>
            <SearchSimple
                id={"txt_rt_search"}
                setSearchResults={setResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                searchElement={searchElement}
                setSearch={setSearch}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                contractorId={null}
                supplierId={null}
                setSimpleSearch={setSimpleSearch}
            />

            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_haven_not_created_any_reader_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_mrt_create'} card={true}
                                                   onClick={() => setReaderModalShow(true)}
                                                   name={'create_new_reader'}/>
                                 } </>
                             : undefined
                         }
            />

            {pagination()}

            { readerModalShow &&
                <CreateReaderModal
                    onHide={()=>setReaderModalShow(false)}
                    show={readerModalShow}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteReaderShow}
                onHide={() => setDeleteReaderShow(false)}
                onClickFn={() => deleteSelectedReader()}
                data={selectedList}
                title_modal={t('delete_reader')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('reader_s')}
            />
        </>
    );
};

export default MainReaderTable;
